import React from 'react';
import { LuZap } from 'react-icons/lu';
import './styles.css';

export default function IdeaReviewCard({ 
    guidingQuestion, 
    selectedIdeasCount, 
    isInKnowledgeBase, 
    onToggle 
}) {
    return (
        <div className="idea-review-card">
            <div className="idea-review-content">
                <div className="idea-review-text">
                    <h4 className="guiding-question-text">
                        {guidingQuestion.text}
                    </h4>
                    <div className="selected-ideas-info">
                        <LuZap className="lightning-icon" />
                        <span className="ideas-count-text">
                            Brainstorm {selectedIdeasCount} ideias selecionadas
                        </span>
                    </div>
                </div>
                
                <div className="idea-review-toggle">
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={isInKnowledgeBase}
                            onChange={onToggle}
                        />
                        <span className="toggle-slider"></span>
                    </label>
                </div>
            </div>
        </div>
    );
}
